module.exports = __webpack_public_path__ + "static/media/BENIN.55f57b17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/BENIN.svg
// module id = 370
// module chunks = 25